import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
    clearIndicator: {
        display: "none !important",
    },
}));

export default useStyles;
